import { t } from 'i18next'

export const discountOptions = [
   { name: t('products.discount'), value: 'products.discount' },
   { name: t('brands.discount'), value: 'brands.discount' }
]

export const PAGE_LIMIT = 7
